import { flow } from 'lodash/fp'
import { stringifyUrl } from 'query-string'

const createQuery = (size: number) => ({ fit: 'crop', w: size.toString(), h: size.toString() })

export const createImgixParams = flow(createQuery, query => (url: string) => stringifyUrl({ url, query }))
